const CAMPAIGN_LOGS = "CAMPAIGN_LOGS";
const IS_LOGS_LOADING = "IS_LOGS_LOADING";

export { CAMPAIGN_LOGS, IS_LOGS_LOADING };
